import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pagination: { page: 0, pageSize: 15 },
  sortModel: [{ field: "created", sort: "desc" }], // default sort for tasks
  searchText: "",
};

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
     resetPage: state => {
      state.pagination.page = 0;
    },
    resetState: (state) => Object.assign(state, initialState),
  },
});

export const { setPagination, setSortModel, setSearchText, resetState,resetPage} = taskSlice.actions;
export default taskSlice.reducer;
